import { Component, OnInit } from "@angular/core";
import { CustomJsService } from "src/app/shared/custom-js.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import thLocale from "@fullcalendar/core/locales/th";
import { ReportsService } from "../reports.service";
import { SportService } from "src/app/sports/sport.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-public-sport",
    templateUrl: "./public-sport.component.html",
    styleUrls: ["./public-sport.component.scss"],
})
export class PublicSportComponent implements OnInit {
    public fixtures: any = null;
    public calendarPlugins: any;
    public sportData: any = null;

    constructor(
        private spinner: NgxSpinnerService,
        private reportsService: ReportsService,
        private sportService: SportService,
        private router: Router
    ) {
        // this.spinner.show();
        document.querySelector("body").classList.add("public-content");
        this.sportService.getPublicSports().subscribe((res) => {
            this.sportData = res.data;
        });
    }

    ngOnInit() {}

    goSportCategory(id) {
        this.router.navigate([`/report/public-sport/${id}`]);
    }
}
